
import Vue from "vue";
import adminHeader from "@/components/AdminHeaderCom.vue";
import adminMenu from "@/components/AdminMenuCom.vue";
import SignarlUtil from "@/assets/js/SignarlUtil";
import { StoreTypes } from "@/assets/js/Types";
import { MenuDetail } from "@/assets/js/Model/ResponseModel";
import Utils from "@/assets/js/Utils";
export default Vue.extend({
  components: { adminHeader, adminMenu },
  mounted() {
    const ret = new SignarlUtil(this);
    ret.reStartSign();
    this.getMenu();
  },
  data() {
    return {
      showTitle: Utils.getHidenTitle() == false,
      showMenu: false,
      showAlarm: false,
      menus: [] as any[],
      alarm: {} as any,
    };
  },
  watch: {
    "$store.state.alarmAction"() {
      const list: any[] = this.$store.state.alarmList;
      if (list && list.length > 0) {
        const first = list[0];
        // const animate: any = this.$refs.animate;
        // animate.start(true);
        // this.currentAlarm.deviceName = first.deviceName;
        // this.currentAlarm.deviceTypeName = first.deviceTypeName;
        // this.currentAlarm.alarmTypeName = first.alarmTypeName;
        // this.currentAlarm.updateTime = first.updateTime;
        // list.forEach((x: any) => {
        //   this.alarms.push(x);
        // });
        this.showAlarm = true;
        this.alarm.deviceName = first.deviceName;
        this.alarm.deviceTypeName = first.deviceTypeName;
        this.alarm.alarmType = first.alarmTypeName;
        this.alarm.alarmTime = first.updateTime;
      }
    },
    $route(to, from) {
      console.log(to, from);
      this.getMenu();
    },
  },
  methods: {
    sliderClick() {
      this.showMenu = !this.showMenu;
    },
    getMenu() {
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      if (project) {
        this.menus = project.menu.childrens;
      }
      if (this.menus.length == 0) {
        window.location.reload();
      }
    },
    menuClick(menu: MenuDetail) {
      if (this.$route.path.toLowerCase() != menu.path.toLowerCase())
        this.$router.push(menu.path);
      this.showMenu = false;
    },
  },
});
